import { useEffect, useRef } from 'react'
import styles from './Downloads.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import LeftContents from './LeftContents'
import { LeftContentDataType } from './types/types'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

gsap.registerPlugin(ScrollTrigger)

const leftContentData: LeftContentDataType = {
  titleVol: <>ユーザビリティチェックリスト</>,
  alt: 'ユーザビリティチェックリスト',
  readText: <>noteで3,300いいね獲得！UIUXデザイナーが実案件から学んだ、本当に役立つUIデザインの法則50</>,
  imgLarge: '/images/img/download/usabilitychecklist/thumbnail_usa.webp',
  imgCapture: '/images/img/download/usabilitychecklist/capture_usa.webp',
  firstContentTitle: 'このような方におすすめ',
  firstHalf: (
    <>
      この資料では10のヒューリスティクスをもとに、デザインリニューアルやサービスの新規立ち上げの際、UIデザイナーとして最低限知っておきたい基本の50個について解説しております。UIデザインの「あるある」に対する改善案や、今すぐ使えるチェックリストを用いて診断したい方におすすめの資料です。
    </>
  ),
  secondContentTitle: 'この資料でわかること',
  secondHalf1: 'UIデザインの「あるある」な失敗例と改善策',
  secondHalf2: 'UIデザイナーとして最低限知っておくべき基本の50個',
  secondHalf3: '',
}

const DownloadUsabilityChecklist: React.FC = () => {
  const title_category = useRef<HTMLSpanElement>(null)
  const title_page = useRef<HTMLSpanElement>(null)
  useHubSpotGenerate('na1', '9395227', 'fa80399a-2972-4238-93b9-ecac59c649f2', '#hbspt')
  useEffect(() => {
    gsap.set([title_category.current, title_page.current, `.${styles.read_text}`, `.${styles.section}`], {
      opacity: 0,
      y: 50,
    })

    const timeline = gsap.timeline({
      defaults: {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: Power4.easeOut,
      },
    })

    const commonTo = { opacity: 1, y: 0 }

    timeline
      .to(title_category.current, commonTo, 0.2)
      .to(title_page.current, commonTo, 0.5)
      .to(`.${styles.read_text}`, commonTo, 0.8)
      .to(`.${styles.section}`, commonTo, 1.1)
  }, [])

  return (
    <article className={`${styles.main} downloadArea`}>
      <section className={styles.contents}>
        <h1 className={styles.ttl}>
          <span ref={title_category}>Download</span>
          <span ref={title_page}>{leftContentData.titleVol}</span>
        </h1>
        <p className={styles.read_text}>{leftContentData.readText}</p>
        <section className={styles.section}>
          <LeftContents leftContentData={leftContentData} isSecondContent={true} />
          <div className={styles.content}>
            <div className={styles.title_group}>
              <p className={styles.whitepaper}>
                ご入力いただいたメールアドレス宛に、資料ダウンロード用URLを送付いたします。
              </p>
              <p className={styles.notice}>※ 全ての項目をご入力ください。</p>
            </div>
            <div id="hbspt"></div>
          </div>
        </section>
      </section>
      <MailmagazineLink />
    </article>
  )
}

export default DownloadUsabilityChecklist
